import { useQuery } from '@tanstack/react-query';

import { useApi } from '@/context/api';
import { useAuth } from '@/context/auth';

export const usePermissionQueryActions = () => {
  const { auth } = useAuth();
  const {
    permissionController: { v1PermissionsList },
  } = useApi();

  const useGetPermissions = () =>
    useQuery({
      enabled: Boolean(auth),
      queryKey: ['permissions'],
      queryFn: async () => {
        const { data } = await v1PermissionsList();
        return data;
      },
    });

  return { useGetPermissions };
};
